// Copy-link share buttons (the event page's Share this post - Views/Partials/EventDetails.cshtml).
// A [data-copy-link] button copies its URL (or the page's) to the clipboard, marks itself
// is-copied for a moment, and says so in the nearest [data-copy-link-status] for screen readers.
// is-copied is what shows the tick and the "Link copied" bubble (_event-page.scss).

const COPIED_FOR_MS = 2000;

export function initCopyLinks() {
    document.querySelectorAll<HTMLButtonElement>('[data-copy-link]').forEach(button => {
        const status = button.closest('.event-share, body')?.querySelector<HTMLElement>('[data-copy-link-status]');
        let timer: number | undefined;

        button.addEventListener('click', async () => {
            const url = button.dataset.copyLink || window.location.href;

            try {
                await navigator.clipboard.writeText(url);
                button.classList.add('is-copied');
                if (status) {
                    status.textContent = 'Link copied';
                }
            } catch {
                // No clipboard access (an insecure origin, or permission refused): offer the URL instead.
                window.prompt('Copy this link', url);
                return;
            }

            window.clearTimeout(timer);
            timer = window.setTimeout(() => {
                button.classList.remove('is-copied');
                if (status) {
                    status.textContent = '';
                }
            }, COPIED_FOR_MS);
        });
    });
}
